var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"left","type":"error","rounded":false}},[_vm._v(" "+_vm._s(_vm.warningText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }